import DownloadSerice from "@/services/DownloadSerice";

export const namespaced = true;

export const state = {
  downloadProfile: [],
};

export const mutations = {
  setDownloadProfile(state, downloadProfile) {
    state.downloadProfile = downloadProfile;
  },
};

export const actions = {
    downloadUserProfile({ commit, dispatch }, { udid, dt_from, dt_to }) {
    return DownloadSerice.downloadUserProfile({ udid, dt_from, dt_to })
      .then((res) => {
        // commit("setDownloadProfile", res.data);
        // return res.data;
        commit("setDownloadProfile", res);
        return res;
      })
      .catch((e) => {
        dispatch("setError", e, { root: true });
        return Promise.reject(e);
      });
  },
};

